"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSmsCodeByPhone = exports.sendSmsCodeByAccount = exports.getSmsBid = void 0;
var _request = _interopRequireWildcard(require("../utils/request"));
var _consts = require("../consts");
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * 通过业务标识来获取该接口是否需要验证码，以及验证码的BID
 */
var getSmsBid = function getSmsBid(sourceType) {
  return _request.default.get("".concat(_consts.MESSAGE_API_URL, "/getBidInfo?sourceType=").concat(sourceType), {
    headers: {
      'Content-Type': _request.CONTENT_TYPE.URLENCODED
    }
  });
};
/**
 * 发送验证码，新版本接口。通过手机号
 * @param param 短信参数
 */
exports.getSmsBid = getSmsBid;
var sendSmsCodeByPhone = function sendSmsCodeByPhone(param) {
  // return request.post(`${MESSAGE_API_URL}/sendByPhone`, { data: param });
  return _request.default.post("".concat(_consts.MESSAGE_API_URL, "/sendByPhone"), {
    data: _qs.default.stringify(param),
    headers: {
      'Content-Type': _request.CONTENT_TYPE.URLENCODED
    }
  });
};
/**
 * 发送验证码，新版本接口。通过账号
 * @param param 短信参数
 */
exports.sendSmsCodeByPhone = sendSmsCodeByPhone;
var sendSmsCodeByAccount = function sendSmsCodeByAccount(param) {
  return _request.default.post("".concat(_consts.MESSAGE_API_URL, "/sendByAccount"), {
    data: param
  });
};
exports.sendSmsCodeByAccount = sendSmsCodeByAccount;